import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { AuthContext } from "../../AuthProvider";
import { Feed as FeedType } from "../../types/api/Feed";
import { Layout } from "../../Layout";
import { handleError } from "../../utils/handleError";
import { ArrowLeft } from "react-feather";
import { Feed } from "../../components/Feed";

export function FeedDetail() {
  const { session } = useContext(AuthContext);
  const { feedId } = useParams();
  const [feed, setFeed] = useState<Partial<FeedType> | null>(null);

  useEffect(() => {
    const getFeed = async () => {
      if (!feedId) return;

      let { data: feed, error } = await supabase
        .from("feeds")
        .select(
          "id, _id, name, slug, auto_publish, auto_post_as, webhook, instance_url, requirements, post_template_override"
        )
        .eq("id", parseInt(feedId))
        .single();

      if (error) {
        handleError(error);
      }

      setFeed(feed);
    };

    if (feedId) {
      getFeed();
    }
  }, [session, feedId]);

  console.log("FeedDetail", { feedId, feed });

  return (
    <Layout>
      <div className="container  max-w-3xl py-10 mx-auto">
        <>
          <div className="flex items-center gap-4 mb-8">
            <Link to="/feeds" className="btn btn-ghost btn-circle">
              <ArrowLeft />
            </Link>
            <div className="prose">
              <h1 className="">Feed Details</h1>
            </div>
          </div>

          {feed && <Feed item={feed} />}
        </>
      </div>
    </Layout>
  );
}
